var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_11576)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16659 2.49999C3.24611 2.49999 2.49992 3.24619 2.49992 4.16666C2.49992 5.08714 3.24611 5.83333 4.16659 5.83333C5.08706 5.83333 5.83325 5.08714 5.83325 4.16666C5.83325 3.24619 5.08706 2.49999 4.16659 2.49999ZM0.833252 4.16666C0.833252 2.32571 2.32564 0.833328 4.16659 0.833328C6.00753 0.833328 7.49992 2.32571 7.49992 4.16666C7.49992 6.00761 6.00753 7.49999 4.16659 7.49999C2.32564 7.49999 0.833252 6.00761 0.833252 4.16666Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 14.1667C14.9129 14.1667 14.1667 14.9129 14.1667 15.8333C14.1667 16.7538 14.9129 17.5 15.8333 17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333C17.5 14.9129 16.7538 14.1667 15.8333 14.1667ZM12.5 15.8333C12.5 13.9924 13.9924 12.5 15.8333 12.5C17.6743 12.5 19.1667 13.9924 19.1667 15.8333C19.1667 17.6743 17.6743 19.1667 15.8333 19.1667C13.9924 19.1667 12.5 17.6743 12.5 15.8333Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33338 4.16666C8.33338 3.70642 8.70647 3.33333 9.16671 3.33333H14.4167C16.9981 3.33333 17.9289 6.71051 15.6587 7.97624L5.9881 13.4785C5.2633 13.8812 5.49965 15 6.41671 15H10.8334C11.2936 15 11.6667 15.3731 11.6667 15.8333C11.6667 16.2936 11.2936 16.6667 10.8334 16.6667H6.41671C3.83529 16.6667 2.90456 13.2895 5.17466 12.0238L14.8453 6.52149C15.5701 6.11883 15.3338 4.99999 14.4167 4.99999H9.16671C8.70647 4.99999 8.33338 4.6269 8.33338 4.16666Z",
    fill: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_11576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/Route.e88c46807c4412e932adc2315462876e.svg";
export { ForwardRef as ReactComponent };